import { useRouter } from "next/dist/client/router";
import { useContext, useRef } from "react";
import { useForm } from "react-hook-form";
import { setCookies, checkCookies, removeCookies } from "cookies-next";
import CloseIcon from "../../public/assets/icons/closeIcon.svg";
import ReactDOMServer from "react-dom/server";
import Swal from "sweetalert2";
import styles from "../../styles/pages/form.module.scss";
import Input from "../Input/Input";
import { ApplicationContext } from "../../context/ApplicationContext";


const AccessForm = ({ properties, loginData }) => {
    const { setShowLoader } = useContext(ApplicationContext)
    const router = useRouter();
    const scrollToRef = useRef(null);
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const onSubmit = async (event) => {
        setShowLoader(true);
        const res = await fetch(
            `${process.env.NEXT_PUBLIC_FE_LOGIN}`,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    username: event.email,
                    password: event.password,
                }),
            }
        );

        const resjs = await res.json();

        if (resjs?.result == false) {
            setShowLoader(false);
            Swal.fire({
                title: properties[resjs.message],
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                closeButtonHtml: ReactDOMServer.renderToString(<CloseIcon />),
            });
        } else {
            if (resjs?.response && !resjs.response.error) {
                const loyalty = await fetch(
                    `${process.env.NEXT_PUBLIC_FE_EMAIL}` +
                    event.email
                );

                const loyaltyjs = await loyalty.json();
                if (checkCookies("myarea")) {
                    removeCookies("myarea");
                }
                if (loyaltyjs?.response?.programKeys) {
                    setCookies(
                        "myarea",
                        {
                            access_token: resjs.response.access_token,
                            refresh_token: resjs.response.refresh_token,
                            loyalty: true,
                            first_name: resjs.response.first_name
                        },
                        {
                            maxAge: 3600,
                        }
                    );
                    router.reload()
                } else {
                    setCookies(
                        "myarea",
                        {
                            access_token: resjs.response.access_token,
                            refresh_token: resjs.response.refresh_token,
                            loyalty: false,
                            first_name: resjs.response.first_name
                        },
                        {
                            maxAge: 3600,
                        }
                    );
                    router.reload()
                }
            } else {
                // setShowLoader(false);
                Swal.fire({
                    title: resjs.response.error_description,
                    // text: 'Booking an experience is not available at the moment.',
                    showCloseButton: true,
                    showCancelButton: false,
                    showConfirmButton: false,
                    closeButtonHtml: ReactDOMServer.renderToString(<CloseIcon />),
                });
            }
        }
    };
    return (
        <>
            <div className={styles.formContainer} ref={scrollToRef}>
                {loginData.items && (
                    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                        {loginData.items.map((f, i) => {
                            const d = f.field;

                            return (
                                <div key={"login-" + i} className={styles.inputContainer}>
                                    <Input
                                        key={"login-" + i}
                                        id={d.type}
                                        name={d.name}
                                        placeholder={d.placeholder}
                                        type={d.type}
                                        errorCheck={errors[d.name]}
                                        error={d.error}
                                        inputProps={{
                                            ...register(`${d.name}`, {
                                                required: d.error ? true : false,
                                                pattern:
                                                    d.type === "email"
                                                        ? /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9\-]+(\.[a-zA-Z0-9\-]+)*(\.[a-zA-Z]{2,})$/
                                                        : null,
                                            }),
                                        }}
                                    />
                                </div>
                            );
                        })}
                        <a
                            href={loginData.links[1]?.url}
                            target={loginData.links[1]?.target}
                        >
                            {loginData.links[1]?.title}
                        </a>
                        <button className={styles.button}>
                            {loginData.button_title}
                        </button>
                        <div className={styles.loginText}> OR </div>
                    </form>
                )}
            </div>
            <div className={styles.buttonContainer}>
                <a
                    href={loginData.links[0]?.url}
                    className="transparent"
                >
                    <button className={styles.button}>
                        {loginData.links[0]?.title}
                    </button>
                </a>
            </div>
        </>
    )
}

export default AccessForm;